import React, { useState, useEffect } from 'react';
import { oneOf, string } from 'prop-types';
import equal from 'fast-deep-equal';
import { categoryShape } from 'shapes';
import { OptionalFilters } from 'modules';
import { useFeatureFlags, useSponsoredProducts } from 'hooks';

import { getMerchandizingBooster, getSponsoredProductsBooster } from 'utils';

export const ProductBooster = ({ category, modelId, pageType }) => {
    const categoryId = category?.id;
    const [{ hasAlternateEngine, hasSponsoredProducts }] = useFeatureFlags({
        hasAlternateEngine: 'relevance.search.ranking',
        hasSponsoredProducts: 'relevance.listing.sponsored.products',
    });
    const [sponsoredProducts] = useSponsoredProducts();

    const [merchandizingBooster, setMerchandizingBooster] = useState(
        pageType === 'category'
            ? getMerchandizingBooster({
                  hasAlternateEngine,
                  modelId,
                  categoryId,
              })
            : [],
    );

    const [sponsoredProductsBooster, setSponsoredProductsBooster] = useState(
        getSponsoredProductsBooster({
            adsInfo: sponsoredProducts.adsInfo,
            hasSponsoredProducts,
        }),
    );

    useEffect(() => {
        if (pageType === 'category') {
            const newMerchandizingBooster = getMerchandizingBooster({
                hasAlternateEngine,
                modelId,
                categoryId,
            });
            if (!equal(newMerchandizingBooster, merchandizingBooster))
                setMerchandizingBooster(newMerchandizingBooster);
        }
    }, [hasAlternateEngine, modelId, categoryId, pageType]);

    useEffect(() => {
        const newSPBooster = getSponsoredProductsBooster({
            adsInfo: sponsoredProducts.adsInfo,
            hasSponsoredProducts,
        });
        if (!equal(newSPBooster, sponsoredProductsBooster))
            setSponsoredProductsBooster(newSPBooster);
    }, [sponsoredProducts.adsInfo]);

    const productBooster = [
        ...sponsoredProductsBooster,
        ...merchandizingBooster,
    ];

    return <OptionalFilters defaultRefinement={productBooster} />;
};

ProductBooster.displayName = 'ProductBooster';

ProductBooster.propTypes = {
    category: categoryShape, // eslint-disable-line react/no-unused-prop-types
    modelId: string,
    pageType: oneOf(['category', 'search']).isRequired,
};

ProductBooster.defaultProps = {
    category: undefined,
    modelId: undefined,
};

export default ProductBooster;
